@import "shared/design-system/style";

.indicator__container {
  display: flex;
  gap: $spacer-large;
  padding: 0;
  border-bottom: 1px solid $highlight-subdued;
  &:last-child {
    border-bottom: none;
  }
  .indicator__item {
    width: 100%;
    border-bottom: 1px solid $highlight-subdued;
    padding: $spacer-large 0;
    &:last-child {
      border-bottom: none;
    }
    .indicator__details {
      .details__item {
        margin-bottom: $spacer-small;
      }
    }
  }
}

.forecast__container,
.details__item > * {
  @include transition-base(all, 0.15s);
}

.forecast__container {
  margin-bottom: $spacer-small;
  border: 1px solid $grey-base;
  border-radius: $spacer-tiny;
  display: flex;
  padding: $spacer-medium;
  flex-direction: column;
  text-align: center;
  align-items: center;
  justify-content: center;
  .forecast__explainer {
    margin-bottom: $spacer-small;
  }
  svg {
    path {
      fill: $highlight;
    }
  }
}

.forecast__item {
  font-size: $display-medium;
}

.edit__container {
  display: flex;
  align-items: center;
  justify-content: center;
  div:hover {
    svg {
      transform: rotate(10deg);
    }
  }
  svg {
    height: 24px;
    width: 24px;
    @include transition-base(transform, 0.15s);
  }
}

@supports (display: grid) {
  @include breakpoint-larger-than-medium {
    .indicator__details {
      display: grid;
      gap: $spacer-medium;
      grid-template-columns: 2fr 4fr 1fr;
      .forecast__container {
        grid-row: 1 / 3;
      }
    }
  }
}

.editable_content {
  border-radius: 8px;
}

.editable_content_big {
  border-radius: 8px;
  min-height: 140px;
}

.attachment__container {
  .attachment__icon {
    margin-right: $spacer-tiny;
  }
  > * {
    cursor: pointer;
  }
  .remove {
    margin-left: $spacer-tiny;
    svg {
      color: $critical;
    }
    opacity: 0;
    @include transition-base(opacity, 0.15s);
  }
  &:hover {
    .remove {
      opacity: 1;
    }
  }
}
